//表格选择器配置

export default {
	pageSize: 10,						//表格每一页条数
	parseData: function (res, systeid) {
		if (res) {
			if (systeid === 0) {
				return {
					data: res.items,
					rows: res.items,		//分析行数据字段结构
					total: res.totalCount,		//分析总数字段结构
					msg: "",			//分析描述字段结构
					code: 200				//分析状态字段结构
				}
			} if (systeid === 1) {
				return {
					data: res.items,
					rows: res.items,		//分析行数据字段结构
					total: res.totalCount,		//分析总数字段结构
					msg: "",			//分析描述字段结构
					code: 200				//分析状态字段结构
				}
			} if (systeid === 2) {
				return {
					data: res.records,
					rows: res.records,		//分析行数据字段结构
					total: res.total,		//分析总数字段结构
					msg: "",			//分析描述字段结构
					code: 200				//分析状态字段结构
				}
			}else {
				return {
					data: res.items,
					rows: res.items,		//分析行数据字段结构
					total: res.totalCount,		//分析总数字段结构
					msg: "",			//分析描述字段结构
					code: 200				//分析状态字段结构
				}
			}

		} else {
			return {
				data: [],
				rows: [],		//分析行数据字段结构
				total: 0,		//分析总数字段结构
				msg: "",			//分析描述字段结构
				code: 200		//分析状态字段结构
			}
		}
	},
	request: [
		{
			page: 'page',					//规定当前分页字段
			pageSize: 'pageSize',			//规定一页条数字段
			keyword: 'keyword'				//规定搜索字段
		},
		{
			//转化
			page: 'page',					//规定当前分页字段
			pageSize: 'pageSize',			//规定一页条数字段
			keyword: 'keyword'				//规定搜索字段
		},
		{
			//视频库
			page: 'current',					//规定当前分页字段
			pageSize: 'size',			//规定一页条数字段
			keyword: 'keyword'				//规定搜索字段
		},
	],
	props: {
		label: 'label',					//映射label显示字段
		value: 'value',					//映射value值字段
	}
}
